class Comparison {
  constructor() {
    if ($('.algolia-listing-pages').length) {
      return;
    }
    this.root = '.pc-Comparison';
    this.reConstructor = this.reConstructor.bind(this);
    this.handleEnterWaypoint = this.handleEnterWaypoint.bind(this);
    this.handleExitWaypoint = this.handleExitWaypoint.bind(this);
    this.handleColumnClose = this.handleColumnClose.bind(this);
    this.scopedNodeList = this.scopedNodeList.bind(this);
    this.tableElement = this.tableElement.bind(this);
    $(document).on(
      'click',
      '.pc-Comparison-productCloser',
      this.handleColumnClose
    );
    this.reConstructor();
  }

  reConstructor() {
    this.el().data('Comparison', this);
    this.registerWaypoint(
      this.scopedNodeList('.pc-Comparison .pc-ProductCard-details'),
      {offset: '12px', handler: this.handleEnterWaypoint}
    );
    return this.registerWaypoint(this.scopedNodeList('.sb-Footer'), {
      offset: '86px',
      handler: this.handleExitWaypoint
    });
  }

  registerWaypoint(target, {offset, handler}) {
    const options = {
      offset,
      handler
    };
    return $(target).eq(0).waypoint(options);
  }

  // Event Handlers

  el() {
    return this.scopedNodeList(this.root).eq(0);
  }

  handleEnterWaypoint(direction) {
    if (direction === 'down') {
      return this.el().addClass('is-scrolled');
    } else {
      return this.el().removeClass('is-scrolled');
    }
  }

  handleExitWaypoint(direction) {
    if (direction === 'down') {
      return this.el().addClass('is-scrolledOut');
    } else {
      return this.el().removeClass('is-scrolledOut');
    }
  }

  handleColumnClose(evt) {
    evt.preventDefault();
    const column = $(evt.target).parents('td');
    const idx = column.index() + 1;
    this.removeColumn(idx);
    if (this.currentColumnCount() === 0) {
      $.magnificPopup.close();
    }
    return $(document).trigger('removeItem.compare', column.data('style-id'));
  }

  // Private

  scopedNodeList(selector) {
    return $(selector);
  }

  removeColumn(idx) {
    const from = this.currentColumnCount();
    this.el().find(`td:nth-child(${idx})`).not('.pc-Comparison-title').remove();
    return this.updateColumnCount(from, this.currentColumnCount());
  }

  updateColumnCount(from, to) {
    this.tableElement().addClass(`pc-Comparison-products--${to}`);
    return this.tableElement().removeClass(`pc-Comparison-products--${from}`);
  }

  currentColumnCount() {
    return this.el().find('tbody tr:nth-child(1) td').length - 1;
  }

  tableElement() {
    return this.el().find('table').eq(0);
  }
}

jQuery(() => (ProductCatalog.Comparison = new Comparison()));
